import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["open"]
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = ["disabled"]

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'RefundOrderDialog',
  props: {
    open: { type: Boolean },
    orderId: { type: Function }
  },
  emits: ["close", "done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const amount = ref('');
const reason = ref('');
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/orders/${props.orderId()}/refund/`,
            data: {
                amount: amount.value,
                reason: reason.value,
            },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", {
    open: _ctx.open,
    class: "action-dialog"
  }, [
    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Вернуть средства по заказу", -1)),
    _createElementVNode("label", null, [
      _cache[3] || (_cache[3] = _createTextVNode("Сумма возврата ")),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
        type: "number",
        step: "0.01",
        min: "0.01"
      }, null, 512), [
        [_vModelText, amount.value]
      ])
    ]),
    _createElementVNode("label", null, [
      _cache[4] || (_cache[4] = _createTextVNode("Причина ")),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reason).value = $event)),
        rows: "3"
      }, null, 512), [
        [_vModelText, reason.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn--danger",
        disabled: busy.value || !amount.value,
        onClick: submit
      }, _toDisplayString(busy.value ? 'Возвращаю…' : 'Вернуть'), 9, _hoisted_3),
      _createElementVNode("button", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, "Отмена")
    ])
  ], 8, _hoisted_1))
}
}

})